import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export function provideMaterialIconsConfig(icons: Record<string, string>): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const iconRegistry = inject(MatIconRegistry);
      const sanitizer = inject(DomSanitizer);

      for (const [name, path] of Object.entries(icons)) {
        iconRegistry.addSvgIcon(name, sanitizer.bypassSecurityTrustResourceUrl(path));
      }
    }),
  ]);
}
